export default __webpack_public_path__ + "static/media/Normatividad.867e1463.jpg";